/**
 * Picks the message to show for a failed API call.
 *
 * The services answer a failure in two shapes: a {code, message} body from the user-creation
 * paths, and a bare string from several older guards. Reading only `data.message` misses the
 * second.
 *
 * @param {unknown} error the rejected error, normally an axios error
 * @param {string} fallback what to show when the response explains nothing
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback) {
  const data = error?.response?.data;

  if (data && typeof data === "object") {
    const { message } = data;
    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }
  }

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  return fallback;
}

export default getApiErrorMessage;
